export const countTruthy = (...values: unknown[]) =>
  values.reduce<number>((count, val) => count + (val ? 1 : 0), 0);
